import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './services/telemetry';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';

// Block telemetry calls baked into @trimble-oss/trimble-id SDK (G-9DHNE789XG).
// The SDK sends SDK-usage events to a Trimble-owned GA4 property with no
// opt-out mechanism in v1.0.0. This intercept returns a silent 204 so the SDK
// doesn't log errors, but no data leaves the browser.
const _originalFetch = window.fetch.bind(window);
window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
  const url =
    typeof input === 'string'
      ? input
      : input instanceof URL
      ? input.href
      : (input as Request).url;
  if (url && url.includes('google-analytics.com')) {
    return Promise.resolve(new Response(null, { status: 204 }));
  }
  return _originalFetch(input, init);
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
